import { render, staticRenderFns } from "./HighValueGoodsPolicy.vue?vue&type=template&id=577124fc&scoped=true"
import script from "./HighValueGoodsPolicy.vue?vue&type=script&lang=js"
export * from "./HighValueGoodsPolicy.vue?vue&type=script&lang=js"
import style0 from "./HighValueGoodsPolicy.vue?vue&type=style&index=0&id=577124fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577124fc",
  null
  
)

export default component.exports